import { Popover } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { apiSdk } from '@/httpClient';
import authService from '@/services/authService';

const languages = [
  {
    lang: 'en',
    flag: require('@/assets/images/flags/uk.png'),
    name: 'English',
  },
  {
    lang: 'fr',
    flag: require('@/assets/images/flags/fr.png'),
    name: 'Français',
  },
];
const LanguageDropdownContent = () => {
  const { i18n } = useTranslation();
  // Choix enregistré sur le compte (retrouvé à la prochaine connexion, sur tout navigateur) ; hors connexion, sur ce
  // navigateur seulement.
  const changeLanguage = async (l: string, e: any) => {
    e.preventDefault();
    if (authService.getAccessToken()) {
      await apiSdk.UserService.language({ language: l }).catch(() => undefined);
    }
    await i18n.changeLanguage(l);
    window.location.reload();
  };

  return (
    <div>
      {languages.map(l => {
        return (
          <div
            style={{ marginTop: 5, display: 'block', cursor: 'pointer' }}
            onClick={e => {
              changeLanguage(l.lang, e);
            }}
          >
            <img src={l.flag} alt={l.name} style={{ width: 20, marginRight: 10, borderRadius: 2 }} />
            <span style={{ color: 'rgb(90, 95, 125)' }}>{l.name}</span>
          </div>
        );
      })}
    </div>
  );
};
export default function LanguageSelector() {
  const { i18n } = useTranslation();

  const currentLanguage = React.useMemo(() => {
    if (i18n.language === 'en') {
      return languages[0];
    }
    return languages[1];
  }, [i18n.language]);
  return (
    <Popover placement="bottomRight" content={<LanguageDropdownContent />}>
      <img src={currentLanguage.flag} alt="language" style={{ width: 20, borderRadius: 2, cursor: 'pointer' }} />
    </Popover>
  );
}
